import React from 'react';

const Logo = () => {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M22.2505 10H19.1997C19.2131 10.9587 19.0349 11.9106 18.6754 12.8002C18.3159 13.6898 17.7822 14.4995 17.1055 15.1822C16.4287 15.8649 15.6223 16.407 14.7332 16.777C13.844 17.1471 12.8898 17.3376 11.926 17.3376C10.9622 17.3376 10.008 17.1471 9.11881 16.777C8.22965 16.407 7.42326 15.8649 6.7465 15.1822C6.06975 14.4995 5.5361 13.6898 5.17659 12.8002C4.81707 11.9106 4.63884 10.9587 4.65226 10H0V10.0799C0.00454471 12.6822 0.863474 15.2118 2.44609 17.2837C4.02871 19.3556 6.24837 20.8565 8.76732 21.558C11.2863 22.2595 13.9666 22.1231 16.4005 21.1697C18.8344 20.2162 20.8886 18.4979 22.2505 16.2761C22.2617 16.2593 22.2716 16.2411 22.2815 16.2243C23.4066 14.3703 24.0009 12.2456 24 10.0799V10.007L22.2505 10Z'
                fill='#6347FF'
            />
            <path
                d='M12.0346 10L12.0929 9.96538H18.9993C19.0122 9.05528 18.8407 8.15172 18.4948 7.30722C18.1488 6.46272 17.6353 5.6941 16.9841 5.04603C16.3329 4.39796 15.5569 3.88336 14.7013 3.53212C13.8457 3.18087 12.9275 3 12 3C11.0725 3 10.1543 3.18087 9.29872 3.53212C8.44311 3.88336 7.66715 4.39796 7.01592 5.04603C6.36469 5.6941 5.85118 6.46272 5.50523 7.30722C5.15927 8.15172 4.98777 9.05528 5.00068 9.96538H11.9763L12.0346 10Z'
                fill='#6347FF'
            />
        </svg>
    );
};

export default Logo;
